/**
 * @file 库文件统一入口
 */
// import { WSLogin } from '@tencent/wslogin';
import wsHybrid from './ws-hybrid';
import wsCommon from './ws-common';
import wsReport from './ws-report';
import wsSchema from './ws-schema';
import wsShare from './ws-share';
import wsUtil from './ws-util';

const { version } = require('../package.json');

export default {
  version,
  wsHybrid,
  wsCommon,
  wsReport,
  wsSchema,
  wsUtil,
  wsShare,
};
